var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1394 4.19526C13.3997 4.45561 13.3997 4.87772 13.1394 5.13807L6.47271 11.8047C6.21236 12.0651 5.79025 12.0651 5.5299 11.8047L2.86323 9.13807C2.60288 8.87772 2.60288 8.45561 2.86323 8.19526C3.12358 7.93491 3.54569 7.93491 3.80604 8.19526L6.0013 10.3905L12.1966 4.19526C12.4569 3.93491 12.879 3.93491 13.1394 4.19526Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.318cf9e3957a8b8b3643d708a050ddbf.svg";
export { ForwardRef as ReactComponent };